<div class="win-streak-container">
  <div class="line-bar">
    <div [style.width]="lineBarHighLightWidth"></div>
  </div>
  <section>
    <div></div>
    <div>
      <div>
        <div [class.activated]="_rushGameService.winStreak > 4">
          <span>x5</span>
        </div>
      </div>
    </div>

    <div>
      <div>
        <div [class.activated]="_rushGameService.winStreak > 9">
          <span>x10</span>
        </div>
      </div>
    </div>

    <div>
      <div>
        <div [class.activated]="_rushGameService.winStreak > 14">
          <span>x15</span>
        </div>
      </div>
    </div>
  </section>
</div>
